import styled from 'styled-components';
import {textSizes, headingSizes} from '@stencil/build-theme';

export const NRUpsellCard = styled.div`
  border-radius: 1.2rem;
  padding: 1.2rem;
  background-color: ${props => props.theme.colors.goWhite.base};
  border: 0.1rem solid #e4e4e4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 1.2rem;
`;

export const NRUpsellTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  justify-content: center;
`;

export const NRUpsellHeading = styled.p`
  ${textSizes.BaseW3}
  color: #4a4a4a;
  flex: 1;

  span {
    color: #156128;
    ${textSizes.BaseW3}
  }
`;

export const NRUpsellTopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.2rem;
`;

export const NRUpsellSubHeading = styled.p`
  ${textSizes.SmallW1}
  color: #717171;
`;

export const NRUpsellRightSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
`;

export const NRUpsellPrice = styled.p`
  ${textSizes.BaseW2}
  color: #156128;
`;

export const NRUpsellButton = styled.button`
  border-radius: 0.4rem;
  border: 1px solid #2276e3;
  padding: 0.75rem 2.4rem;
  background-color: #ffffff;
  color: #2276e3;
  font-size: 1.2rem;
  font-weight: 500; /* Slightly bolder for better readability */
  cursor: pointer;
  transition: all 0.3s ease; /* Smooth transition for hover and active states */

  &:hover {
    background-color: #2276e3;
    color: #ffffff;
    border-color: #2276e3;
    box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2); /* Enhanced shadow for hover state */
  }

  &:active {
    background-color: #1a5db2; /* Darker shade for active state */
    color: #ffffff;
    border-color: #1a5db2;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Reduced shadow for pressed state */
    transform: translateY(1px); /* Pressed effect */
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(34, 118, 227, 0.5); /* Focus ring for accessibility */
  }

  &:disabled {
    background-color: #f0f0f0;
    color: #b0b0b0;
    border-color: #d0d0d0;
    cursor: not-allowed;
    box-shadow: none; /* No shadow for disabled state */
    transform: none; /* No lift or press effect */
  }
`;
